import Vue from 'vue';
import index from './index.vue';
import EventsCalendarView from './view/EventsCalendarView.vue';

//new Vue(App).$mount('#app');

const router = new VueRouter({
    mode: "hash",
    hashbang: true,
    history: true,
    scrollBehavior (to, from, saved) {
        return { x: 0, y: 0}
    },
    routes: [{
        path: '/',
        component: EventsCalendarView
    }]
});


const app = new Vue({router, ...index });
app.$mount('#app');
